<template>
    <div class="guide-text-wrapper">
        <TextEditor class="textarea" maxlength="2000" @change="inputChange" :value="editorVal" />
    </div>
</template>

<script>
import TextEditor from "@/views/zhiji/components/textEditor/Editor";

export default {
    name: "GuideText",
    props: ["data"],
    components: {
        TextEditor
    },
    computed: {
        editorVal() {
            return { text: this.data.content || '' };
        }
    },
    methods: {
        inputChange(data) {
            let newData = Object.assign({}, this.data, {
                content: data.text,
                updateState: "update"
            });

            this.$emit("updateContent", newData);
        }
    }
};
</script>

<style lang="less" scoped>
.guide-text-wrapper {
    position: relative;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;

    /deep/ .textarea-bot-wrapper {
        display: none;
    }
}
</style>
